import React from 'react';
import { Link } from 'react-router-dom';

const PublicProfileLink = ({ username }) => (
  <Link to={`/${username}`}>View Public Profile</Link>
)

export default PublicProfileLink



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/PublicProfileLink.js